<div [class]="classes?.modalWrapper">
    <button type="button" class="close-modal-btn" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
    <div class="imageContainer">
        <picture [spFallbackImg]="formatImageURL(images[0])">
            <source [srcset]="formatImageURLWithResize(images[0])" />
            @if (images.length) {
                <img [src]="formatImageURL(images[0])" alt="0" />
            } @else {
                <div class="blank-wrapper">
                    <img src="./assets/img/websites/lpc-empty-product-icon.svg" alt="product_blank" />
                </div>
            }
        </picture>
    </div>
    <div class="contentWrapper">
        <div class="card-title sp-ui-text">
            <h2>{{ element.name }}</h2>
        </div>

        @if (element.price) {
            <div class="card-price-block sp-ui-text">
                <p class="card-new-price">{{ element.price }} usd</p>
                @if (element.oldPrice) {
                    <p class="card-old-price">{{ element.oldPrice }} usd</p>
                }
            </div>
        }

        <div class="buttonWrapper">
            <a [class]="getBasketButtonStyles" class="card-button">
                <span>{{ basketButton.label }}</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M22.4142 4.58579C23.1953 5.36683 23.1953 6.63317 22.4142 7.41421L11.4142 18.4142C10.6332 19.1953 9.36684 19.1953 8.58579 18.4142L2.58579 12.4142C1.80474 11.6332 1.80474 10.3668 2.58579 9.58579C3.36683 8.80474 4.63317 8.80474 5.41421 9.58579L10 14.1716L19.5858 4.58579C20.3668 3.80474 21.6332 3.80474 22.4142 4.58579Z"
                        fill="white"
                    />
                </svg>
            </a>

            <div class="card-product-counter">
                <span class="counter-control">
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                        <rect y="4" width="10" height="2" rx="1" fill="currentColor" />
                    </svg>
                </span>
                <span class="counter">1</span>
                <span class="counter-control">
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M4 9C4 9.55228 4.44772 10 5 10C5.55228 10 6 9.55228 6 9V6H9C9.55229 6 10 5.55228 10 5C10 4.44772 9.55228 4 9 4H6V1C6 0.447715 5.55228 0 5 0C4.44772 0 4 0.447716 4 1V4H1C0.447715 4 0 4.44772 0 5C0 5.55228 0.447715 6 1 6H4V9Z"
                            fill="currentColor"
                        />
                    </svg>
                </span>
            </div>
        </div>

        <div class="card-description sp-ui-text">
            <div [innerHTML]="element.description | spSafeHtml"></div>
        </div>

        @for (parameter of element.sections; track parameter) {
            <div class="card-parameters sp-ui-text">
                <label> {{ parameter.name }}</label>
                @for (param of parameter.parameters; track param) {
                    <p>{{ param.parameter }}: {{ param.value }}</p>
                }
            </div>
        }
    </div>
</div>
